import React, { useEffect, useState } from "react";
import styles from "./Login.module.css";
import { Routes, Route } from "react-router-dom";
import LoginPage from "./LoginPage";
import ForgotPassword from "./ForgotPass";
import LanguageSwitcher from "./LanguageSwitcher";
import { loadTranslations } from "../../Translation/i18next";
import LoadingContainer from "../LoadingContainer/LoadingContainer";

const Login = () => {
  const [isReady, setIsReady] = useState(false);
  useEffect(() => {
    const initTranslations = async () => {
      await loadTranslations();
      setIsReady(true); // Set to true once translations are loaded
    };

    initTranslations();
  }, []);

  return (
    <LoadingContainer loading={!isReady}>
      <div className={styles.main_container}>
        <div className={styles.right_panel}>
          <div className="flex flex-1 rounded-3xl bg-white w-1/2 min-w-[400px] max-w-[600px] p-12 flex-col">
            <LanguageSwitcher />
            <Routes>
              <Route path="/forgotpassword" element={<ForgotPassword />} />
              <Route path="/*" element={<LoginPage />} />
            </Routes>
          </div>
        </div>
      </div>
    </LoadingContainer>
  );
};

export default Login;
